<template>
  <div id="midTop">
    <div class="bg-color-black d-flex flex-wrap jc-between">
      <div class="item" v-for="item in list" :key="item.title">
        <dv-border-box-3>
          <div class="title">{{item.title}}</div>
          <div class="text">地址：{{item.add}}</div>
          <div class="text">电话：{{item.tel}}</div>
          <div class="text">原因：{{item.reason}}</div>
        </dv-border-box-3>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  data() {
    return {
      list: [
        {
          title: '灯光更换',
          add: '南4号楼602',
          tel: '13800100010',
          reason: '灯光坏了'
        },
        {
          title: '水龙头更换',
          add: '南1号楼602',
          tel: '13600100010',
          reason: '灯光坏了'
        },
        {
          title: '空调控制器更换',
          add: '北2号楼602',
          tel: '13200100010',
          reason: '空调控制器坏了'
        },
        {
          title: '玻璃更换',
          add: '东3号楼602',
          tel: '13800200010',
          reason: '玻璃碎了了'
        },
      ]
    }
  }
}
</script>
    
<style lang="scss" scoped>
$box-height: 300px;
$box-width: 100%;

#midTop {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .item {
    width: 46%;
  }

  .title {
    line-height: 40px;
    text-align: center;
    margin-left: -30px;
    padding-top: 5px;
  }

  .text {
    color: #c3cbde;
      padding-left: 30px;
  }

  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
    